module.exports = __webpack_public_path__ + "static/img/插图.4f72b95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生物制造/插图.png
// module id = W04W
// module chunks = 1